// extracted by mini-css-extract-plugin
export default {"addCategoryPage__container":"AddCategory_addCategoryPage__container__wyOS7"};